import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { EmptyState, ErrorState } from "@/components/empty-state";

export const Route = createFileRoute("/_site/genres")({
  head: () => ({
    meta: [
      { title: "Genres — NexKey.gg" },
      { name: "description", content: "Browse games by genre and find the cheapest keys." },
      { property: "og:title", content: "Genres — NexKey.gg" },
      { property: "og:description", content: "Browse games by genre." },
    ],
    links: [{ rel: "canonical", href: "/genres" }],
  }),
  component: GenresPage,
});

function GenresPage() {
  const genres = useQuery({ queryKey: ["genres-all"], queryFn: () => api.genres() });
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="font-display text-3xl font-bold">Genres</h1>
      <p className="mt-1 text-sm text-muted-foreground">Genres are populated automatically from imported Steam data.</p>
      <div className="mt-6">
        {genres.isError && <ErrorState message={(genres.error as Error).message} />}
        {genres.isSuccess && genres.data.data.length === 0 && (
          <EmptyState title="No genres yet" description="Import Steam games to populate genres." />
        )}
        {genres.isSuccess && genres.data.data.length > 0 && (
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4">
            {genres.data.data.map((g) => (
              <Link
                key={g.id}
                to="/games"
                search={{ genre: g.slug } as any}
                className="rounded-xl border border-border bg-card p-4 hover:border-primary hover:text-primary"
              >
                <div className="font-display text-sm font-semibold">{g.name}</div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
